module.exports = __webpack_public_path__ + "static/media/4-4.9d382050.png";